export default {
  getFacialEmployeeListPagination: (state) => state.pagination,
  getAfterEmployeesSelected: (state) => state.afterSelected,
};
